import AssociationInfo from '@data/models/AssociationInfo';
import { apiCall } from '../axios';
export class AssociationService {
    /**
     * GET /association_info
     *
     * Legacy endpoint behind the multi-property widget (PropertyDatePicker). It
     * reads the legacy association registry, which is a different source than the
     * organization endpoints in `OrganizationService` — the two do not share ids.
     */
    static getAssociationInfo(subDomain) {
        return apiCall(AssociationInfo)('get', '/association_info', {
            sub_domain: subDomain,
        });
    }
}
